import { forwardRef } from 'react';
import { Input as AntInput } from 'antd';
import type { InputProps as AntInputProps, InputRef } from 'antd';
import type { PasswordProps } from 'antd/es/input';

import { cn } from '../../lib/cn';

/**
 * Ô nhập một dòng (§9.3.2). Chuyển tiếp thuần, chỉ ghép class qua `cn()`.
 * Trong biểu mẫu, luôn bọc trong `<Field>` và rải các prop a11y lên control.
 */
export const Input = forwardRef<InputRef, AntInputProps>(function Input({ className, ...props }, ref) {
  return <AntInput ref={ref} className={cn(className)} {...props} />;
});

/** Ô nhập mật khẩu, có nút hiện/ẩn của antd. */
export const InputPassword = forwardRef<InputRef, PasswordProps>(function InputPassword(
  { className, ...props },
  ref,
) {
  return <AntInput.Password ref={ref} className={cn(className)} {...props} />;
});
